module.exports = __webpack_public_path__ + "img/hero-main-3-eng.b11b2b8b.png";